import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { useTranslation } from '@/hooks/useTranslation';
import { registerTranslations } from '@/hooks/useTranslation';
import translations from './translations';
import ContactForm from '@/components/common/ContactForm';

// Registriere die Übersetzungen für diese Seite
registerTranslations('agbPage', translations);

/**
 * AGB-Seite
 * 
 * Die Inhalte werden direkt als HTML definiert
 */

const AgbPage = () => {
  const { t } = useTranslation();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo 
        title={t('agbPage.meta.title')}
        description={t('agbPage.meta.description')}
        canonical="/agb"
      />
      <Layout>
        <main>
          <div className="container mx-auto px-4 py-16">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl font-bold mb-8">{t('agbPage.title')}</h1>
              
              <div className="legal-content prose prose-lg max-w-none">
                <h2>1. Geltungsbereich</h2>
                <p>
                  Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen 
                  Dennis Dittrich (nachfolgend "Anbieter") und dem Kunden geschlossen werden.
                </p>
                <p>
                  Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der 
                  Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
                </p>

                <h2>2. Vertragsschluss</h2>
                <p>
                  Der Vertrag kommt durch die Annahme des Angebots des Anbieters durch den Kunden 
                  zustande. Die Annahme erfolgt durch schriftliche Bestätigung (auch per E-Mail) 
                  oder durch Inanspruchnahme der Leistungen des Anbieters.
                </p>

                <h2>3. Leistungsumfang</h2>
                <p>
                  Der Umfang der vom Anbieter zu erbringenden Leistungen ergibt sich aus der 
                  jeweiligen Leistungsbeschreibung und den getroffenen Vereinbarungen.
                </p>
                <p>
                  Der Anbieter ist berechtigt, die vereinbarten Leistungen zu ändern, zu reduzieren 
                  oder zu ergänzen, soweit dies für den Kunden zumutbar ist.
                </p>

                <h2>4. Preise und Zahlungsbedingungen</h2>
                <p>
                  Alle Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer.
                </p>
                <p>
                  Rechnungen sind innerhalb von 14 Tagen nach Erhalt ohne Abzug zahlbar, sofern 
                  nicht anders vereinbart.
                </p>
                <p>
                  Bei Zahlungsverzug ist der Anbieter berechtigt, Verzugszinsen in Höhe von 9 
                  Prozentpunkten über dem Basiszinssatz zu berechnen.
                </p>

                <h2>5. Mitwirkungspflichten des Kunden</h2>
                <p>
                  Der Kunde ist verpflichtet, dem Anbieter alle für die Erbringung der Leistungen 
                  erforderlichen Unterlagen und Informationen rechtzeitig zur Verfügung zu stellen.
                </p>
                <p>
                  Der Kunde hat die von ihm zur Verfügung gestellten Inhalte auf ihre Rechtmäßigkeit 
                  zu überprüfen und stellt den Anbieter von sämtlichen Ansprüchen Dritter frei, die 
                  auf einer Rechtsverletzung durch diese Inhalte beruhen.
                </p>

                <h2>6. Gewährleistung und Haftung</h2>
                <p>
                  Der Anbieter haftet für Schäden des Kunden nur bei Vorsatz oder grober 
                  Fahrlässigkeit. Dies gilt nicht für Schäden aus der Verletzung von Leben, 
                  Körper oder Gesundheit.
                </p>
                <p>
                  Die Haftung des Anbieters ist auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
                </p>

                <h2>7. Vertragsdauer und Kündigung</h2>
                <p>
                  Die Vertragslaufzeit ergibt sich aus der jeweiligen Vereinbarung.
                </p>
                <p>
                  Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
                </p>

                <h2>8. Datenschutz</h2>
                <p>
                  Der Anbieter erhebt und verwendet personenbezogene Daten des Kunden nur im Rahmen 
                  der gesetzlichen Bestimmungen. Weitere Informationen finden sich in der 
                  Datenschutzerklärung des Anbieters.
                </p>

                <h2>9. Schlussbestimmungen</h2>
                <p>
                  Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.
                </p>
                <p>
                  Sollten einzelne Bestimmungen dieser AGB unwirksam sein, so bleibt der Vertrag 
                  im Übrigen wirksam.
                </p>
              </div>
            </div>
          </div>
          
          <ContactForm />
        </main>
      </Layout>
    </>
  );
};

export default AgbPage; 